export default __webpack_public_path__ + "static/media/4.009507a8.jpg";